module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_014.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_014.png
// module id = 1138
// module chunks = 0